import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/donate-amount.svg'
import _imports_1 from '@/assets/carbon-nfts.svg'
import _imports_2 from '@/assets/life-nfts.svg'
import _imports_3 from '@/assets/carbon-tokens.svg'
import _imports_4 from '@/assets/life-tokens.svg'
import _imports_5 from '@/assets/seed.png'


const _withScopeId = n => (_pushScopeId("data-v-4b3f9f65"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "-mx-4 flex flex-wrap"
}
const _hoisted_2 = { class: "w-full p-2 lg:p-4" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "",
  width: "32"
}, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "font-gray my-2 font-20" }, "Donation Amount", -1))
const _hoisted_5 = { class: "font-20 font-gray font-normal" }
const _hoisted_6 = { class: "w-1/2 p-2 lg:p-4" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "",
  width: "32"
}, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "font-gray my-2 font-20" }, "Carbon NFTs", -1))
const _hoisted_9 = {
  key: 0,
  class: "text-3xl font-semibold"
}
const _hoisted_10 = { class: "w-1/2 p-2 lg:p-4" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: "",
  width: "32"
}, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "font-gray my-2 font-20" }, "Life NFTs", -1))
const _hoisted_13 = {
  key: 0,
  class: "text-3xl font-semibold"
}
const _hoisted_14 = { class: "w-1/2 p-2 pt-4 lg:p-4" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  alt: "",
  width: "32"
}, null, -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "font-gray my-2 font-20" }, "Carbon tokens", -1))
const _hoisted_17 = { class: "text-3xl font-semibold" }
const _hoisted_18 = { class: "w-1/2 p-2 pt-4 lg:p-4" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  alt: "",
  width: "32"
}, null, -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "font-gray my-2 font-20" }, "Life tokens", -1))
const _hoisted_21 = { class: "text-3xl font-semibold" }
const _hoisted_22 = { key: 1 }
const _hoisted_23 = { class: "flex justify-between sm:items-center flex-col-reverse sm:flex-row" }
const _hoisted_24 = { class: "text-3xl font-semibold mt-6 sm:mt-0" }
const _hoisted_25 = { class: "flex space-x-4" }
const _hoisted_26 = { class: "flex sm:block justify-between items-center" }
const _hoisted_27 = { class: "w-full aspect-w-1 aspect-h-1" }
const _hoisted_28 = ["src", "alt"]
const _hoisted_29 = { class: "text-gray-800 number" }
const _hoisted_30 = {
  key: 2,
  class: "py-3 flex items-center space-x-3 flex-col lg:flex-row"
}
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "rounded-lg p-8 max-w-md w-full",
  style: {"background":"#d2f0e6"}
}, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_5,
    alt: "",
    class: "w-full"
  })
], -1))
const _hoisted_32 = { class: "flex-1 text-center pt-4 pb-8" }
const _hoisted_33 = {
  class: "text-64px lg-text-60px font-bold lg:font-semibold",
  style: {"line-height":"80px"}
}
const _hoisted_34 = { class: "text-40px lg-text-36px font-normal text-gray-500 my-2" }

import { computed, defineComponent, ref, watch } from 'vue';
import Moralis from 'moralis';
import { Icon } from '@iconify/vue';
import { useRoute } from 'vue-router';
import {
  GetNFTsInventories,
  NFTsInventories,
  GetDonation,
  Donation,
  GetToken,
  Token,
  NFT,
} from '@/types/MoralisCloud';
import { BIODIVERSITY_NFT_ADDRESS, CARBON_NFT_ADDRESS } from '@/constants';
import useMoralis from '@/composables/useMoralis';
import { numberWithCommas } from '@/composables/format';
import LandingFooter from '@/components/Landing/LandingFooter';
import _ from 'lodash';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const moralis = useMoralis();
defineComponent({
  name: 'InventoryView',
});

const route = useRoute();

// NFTs
const formatTokenID = (tokenID: string) => `#${tokenID.padStart(8, '0')}`;
const requestedCarbonNFT = ref<NFTsInventories>({ entities: [], pageInfo: {} });
const requestedBiodiversityNFT = ref<NFTsInventories>({
  entities: [],
  pageInfo: {},
});
const nftType = computed(() => route.params.type as string);
const userAddress = computed<string>(
  () => moralis.currect.User.current()?.attributes.ethAddress
);
const getNFTAddress = (typeIndex: number) => {
  const addresses = [CARBON_NFT_ADDRESS, BIODIVERSITY_NFT_ADDRESS];
  return addresses[typeIndex];
};
const getNFTs = async (walletAddress: string, nftType: string) => {
  const nftTypes = ['carbon', 'biodiversity'];
  const typeIndex = nftTypes.indexOf(nftType);
  const tokenAddress = getNFTAddress(typeIndex);

  try {
    const result = await moralis.currect.Cloud.run<GetNFTsInventories>(
      'getNFTsInventories',
      {
        walletAddress,
        nftAddress: tokenAddress.toLowerCase(),
        page_number: 1,
        size: 20,
      }
    );
    return result;
  } catch (err) {
    moralis.handleMoralisError(err as Moralis.Error);
    return [];
  }
};

// NFTs filter
const queryString = ref('');
const queryResults = computed(() =>
  (nftType.value == 'carbon'
    ? requestedCarbonNFT
    : requestedBiodiversityNFT
  ).value.entities?.filter((item) => {
    const queryCaseIgnored = new RegExp(queryString.value, 'i');
    const idAndDescription = [
      formatTokenID(item.nftAddress),
      item.nftDescription,
    ];
    return idAndDescription.some((value) => queryCaseIgnored.test(value));
  })
);
const shouldEmptyDisplay = computed(() => {
  const hasPage =
    !!(
      nftType.value == 'carbon' ? requestedCarbonNFT : requestedBiodiversityNFT
    ).value.pageInfo?.page || 1;
  const hasQuery = !!queryString.value;
  return (hasPage || hasQuery) && !queryResults.value?.length;
});

// Token
const requesteTokenDonation = ref<Donation[]>();
const requesteToken = ref<Token[]>();
const getTokens = async (walletAddress: string) => {
  const result = await moralis.currect.Cloud.run<GetToken>('getTokensBalance', {
    walletAddress,
    token: moralis.currect.User.current()?.getSessionToken(),
  });
  result.forEach((e) => {
    e.amount = moralis.currect.Units.FromWei(e.balance, e.decimals);
  });
  return result;
};
const getDonations = async (wallet_address: string) => {
  const result = await moralis.currect.Cloud.run<GetDonation>(
    'getDonationAmount',
    {
      wallet_address,
      token: moralis.currect.User.current()?.getSessionToken(),
    }
  );
  return result;
};

watch(
  [userAddress, nftType],
  async (current) => {
    const [address, currentNFTType] = current;
    if (address && currentNFTType) {
      if (currentNFTType == 'carbon')
        requestedCarbonNFT.value = (await getNFTs(
          address,
          currentNFTType
        )) as NFTsInventories;
      else if (currentNFTType == 'biodiversity')
        requestedBiodiversityNFT.value = (await getNFTs(
          address,
          currentNFTType
        )) as NFTsInventories;
      else if (
        currentNFTType == 'carbon-token' ||
        currentNFTType == 'biodiversity-token'
      )
        requesteToken.value = await getTokens(address);
      else {
        requesteTokenDonation.value = await getDonations(address);

        requestedCarbonNFT.value = (await getNFTs(
          address,
          'carbon'
        )) as NFTsInventories;
        requestedBiodiversityNFT.value = (await getNFTs(
          address,
          'biodiversity'
        )) as NFTsInventories;
        requesteToken.value = await getTokens(address);
      }
    }
  },
  { immediate: true }
);
// tab
const viewTabs = [{ icon: 'ci:grid-big' }, { icon: 'ci:list-ul' }];
const activeView = ref<number>(0);
const viewByCols = computed(() => activeView.value === 0);

const checkType = () => {
  return ['carbon', 'biodiversity'].includes(nftType.value);
};

const sumNft = (arr: NFT[]) => {
  return _.sumBy(arr, (item: NFT) => Number(item.nftAmount));
};

return (_ctx: any,_cache: any) => {
  const _component_BaseBox = _resolveComponent("BaseBox")!
  const _component_BaseInputText = _resolveComponent("BaseInputText")!
  const _component_BaseTabs = _resolveComponent("BaseTabs")!
  const _component_BaseEmpty = _resolveComponent("BaseEmpty")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_unref(nftType) == 'overview')
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_BaseBox, { padding: "p-5" }, {
            default: _withCtx(() => [
              _hoisted_3,
              _hoisted_4,
              (requesteTokenDonation.value)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: _normalizeClass(["flex flex-col lg:flex-row flex-wrap items-start", { 'justify-between': requesteTokenDonation.value.length == 3 }])
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(requesteTokenDonation.value, (item, i) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: _normalizeClass(["text-3xl my-3 font-semibold whitespace-nowrap", { 'flex-1': requesteTokenDonation.value.length != 3 }]),
                        key: i
                      }, [
                        _createTextVNode(_toDisplayString(_unref(numberWithCommas)(item.sum || 0)) + " ", 1),
                        _createElementVNode("span", _hoisted_5, _toDisplayString(item.currency), 1)
                      ], 2))
                    }), 128))
                  ], 2))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_BaseBox, {
            padding: "p-5",
            class: "h-full"
          }, {
            default: _withCtx(() => [
              _hoisted_7,
              _hoisted_8,
              (requestedBiodiversityNFT.value.entities)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_unref(numberWithCommas)(sumNft(requestedCarbonNFT.value.entities) || 0)), 1))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_component_BaseBox, {
            padding: "p-5",
            class: "h-full"
          }, {
            default: _withCtx(() => [
              _hoisted_11,
              _hoisted_12,
              (requestedBiodiversityNFT.value.entities)
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(_unref(numberWithCommas)(sumNft(requestedBiodiversityNFT.value.entities) || 0)), 1))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createVNode(_component_BaseBox, {
            padding: "p-5",
            class: "h-full"
          }, {
            default: _withCtx(() => [
              _hoisted_15,
              _hoisted_16,
              _createElementVNode("div", _hoisted_17, _toDisplayString(_unref(numberWithCommas)(
              parseInt(
                requesteToken.value?.find((e) => e.symbol == 'CARBON')?.amount || '0'
              )
            )), 1)
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_18, [
          _createVNode(_component_BaseBox, {
            padding: "p-5",
            class: "h-full"
          }, {
            default: _withCtx(() => [
              _hoisted_19,
              _hoisted_20,
              _createElementVNode("div", _hoisted_21, _toDisplayString(_unref(numberWithCommas)(
              parseInt(
                requesteToken.value?.find((e) => e.symbol == 'LIFE')?.amount || '0'
              )
            )), 1)
            ]),
            _: 1
          })
        ])
      ]))
    : (_unref(nftType) === 'carbon' || _unref(nftType) === 'biodiversity')
      ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("span", _hoisted_24, _toDisplayString(_unref(numberWithCommas)(
            (_unref(nftType) == 'carbon'
              ? requestedCarbonNFT.value.pageInfo?.count
              : requestedBiodiversityNFT.value.pageInfo?.count) || 0
          )) + " items ", 1),
            _createElementVNode("div", _hoisted_25, [
              _createVNode(_component_BaseInputText, {
                id: "nft-search",
                modelValue: queryString.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((queryString).value = $event)),
                placeholder: "Search id",
                "data-testid": "inventory-search-input"
              }, {
                "head-icon": _withCtx(() => [
                  _createVNode(_unref(Icon), {
                    icon: "bx:bx-search",
                    class: "text-2xl"
                  })
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createVNode(_component_BaseTabs, {
                modelValue: activeView.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((activeView).value = $event)),
                type: "toggle",
                tabs: viewTabs
              }, null, 8, ["modelValue"])
            ])
          ]),
          (_unref(shouldEmptyDisplay))
            ? (_openBlock(), _createBlock(_component_BaseEmpty, {
                key: 0,
                src: require('@/assets/svg/empty-nft.svg'),
                title: "NFT not found",
                description: "You do not own any NFT yet. Please make a donation to earn your NFT.",
                class: "flex-1"
              }, null, 8, ["src"]))
            : (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: _normalizeClass(["grid gap-6 my-6", { 'sm:grid-cols-1 md:grid-cols-2': _unref(viewByCols) }])
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(queryResults), (token) => {
                  return (_openBlock(), _createBlock(_component_BaseBox, {
                    padding: "p-4",
                    key: token.tokenID
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_26, [
                        _createElementVNode("div", {
                          class: _normalizeClass(["sm:items-center", _unref(viewByCols) ? 'flex flex-col' : 'nft-list-item'])
                        }, [
                          _createElementVNode("div", _hoisted_27, [
                            _createVNode(_component_router_link, {
                              to: `/nft-detail/${_unref(nftType)}/${token.nftAddress}`
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("img", {
                                  id: "nft-img",
                                  src: token.nftImageURL,
                                  alt: token.nftDescription,
                                  class: "h-full w-full"
                                }, null, 8, _hoisted_28)
                              ]),
                              _: 2
                            }, 1032, ["to"])
                          ]),
                          _createVNode(_component_router_link, {
                            to: `/nft-detail/${_unref(nftType)}/${token.nftAddress}`,
                            class: _normalizeClass(["text-lg title font-semibold my-4", { 'text-gray-400': !token.nftsDescription }])
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(token.nftDescription || 'n/a'), 1)
                            ]),
                            _: 2
                          }, 1032, ["to", "class"]),
                          _createElementVNode("p", _hoisted_29, " Quantity : " + _toDisplayString(_unref(numberWithCommas)(parseInt(token.nftAmount))), 1)
                        ], 2)
                      ])
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ], 2))
        ]))
      : (['carbon-token', 'biodiversity-token'].includes(_unref(nftType)))
        ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
            _hoisted_31,
            _createElementVNode("div", _hoisted_32, [
              _createElementVNode("div", _hoisted_33, _toDisplayString(_unref(numberWithCommas)(
            parseInt(
              requesteToken.value?.find(
                (e) =>
                  e.symbol == (_unref(nftType) == 'carbon-token' ? 'CARBON' : 'LIFE')
              )?.amount || '0'
            )
          )), 1),
              _createElementVNode("div", _hoisted_34, _toDisplayString(_unref(nftType) == 'carbon-token' ? 'Carbon Tokens' : 'Life Tokens'), 1)
            ])
          ]))
        : _createCommentVNode("", true)
}
}

})